import './Privacy.scss';

const Privacy = () => {
   return (
      <div className='privacy'>
         <div className='privacy__container'>
            <h2>ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ</h2>
            <p className='privacy__text'>
               Політика конфіденційності perlynka-shoes-store.com і політика
               cookie
            </p>
            <p className='privacy__text'>
               Терміни, що використовуються в умовах Політики конфіденційності
               perlynka-shoes-store.com і політики cookie, визначені в Умовах
               використання ресурсів сайту https://perlynka-shoes-store.com/
            </p>
            <p className='privacy__text'>
               perlynka-shoes-store.com цінує право КОРИСТУВАЧІВ на особисте
               життя і нерозголошення персональної інформації. Ця Політика
               конфіденційності - правило, яким користуються всі співробітники
               нашого сервісу. Вона регламентує збір та використання особистої
               інформації, яка може бути запрошена / отримана під час
               відвідування нашого сайту https://perlynka-shoes-store.com/, при
               використанні сервісу, при замовленні, листуванні або телефонній
               розмові. Якщо у Вас виникнуть питання або проблеми в зв'язку з
               конфіденційністю, надсилайте, будь ласка, свої питання або
               зауваження на електронну адресу: perlynka-shoes-store@gmail.com
            </p>
            <p className='privacy__text'>
               perlynka-shoes-store.com гарантує, що будь-яка інформація, в тому
               числі персональні дані, отримані від КОРИСТУВАЧА, не будуть
               надані або іншим способом поширені серед третіх осіб.
            </p>
            <p className='privacy__text'>
               Надана КОРИСТУВАЧЕМ інформація та персональні дані
               використовуються при обробці ЗАМОВЛЕННЯ, для надання КОРИСТУВАЧУ
               доступу до спеціальної інформації та в маркетингових цілях.
            </p>
            <p className='privacy__text'>
               За згодою КОРИСТУВАЧА perlynka-shoes-store.com може здійснювати
               розсилки на адресу електронної пошти Користувача, sms і viber
               розсилки з метою інформування КОРИСТУВАЧА про ТОВАРИ і їх
               характеристики, акції та інші заходи, що проводяться
               perlynka-shoes-store.com.
            </p>
            <p className='privacy__text'>
               КОРИСТУВАЧІ також можуть підписатися на розсилки
               perlynka-shoes-store.com на офіційній сторінці
               perlynka-shoes-store.com на сайті
               https://perlynka-shoes-store.com/.
            </p>
            <p className='privacy__text'>
               КОРИСТУВАЧ,надає свою згоду на обробку персональних даних
               відповідно до ст. 6 Закону України «Про захист персональних
               даних» з наступними умовами:
            </p>
            <p className='privacy__text'>
               - згода дається на обробку своїх персональних даних як без
               використання засобів автоматизації, так і з їх використанням;
            </p>
            <p className='privacy__text'>
               - згода дається на обробку наступних персональних даних:
               прізвище, ім'я; номери контактних телефонів; адреси електронної
               пошти; адреси доставки замовлень.
            </p>
            <p className='privacy__text'>
               Метою обробки персональних даних КОРИСТУВАЧА є також обробка
               ЗАМОВЛЕНЬ для продажу ТОВАРУ і проведення маркетингових
               досліджень.
            </p>

            <p className='privacy__text'>
               В ході обробки персональних даних з персональними даними будуть
               здійснені наступні дії: збір, систематизація, накопичення,
               зберігання, уточнення, використання, блокування, знищення.
            </p>
            <p className='privacy__text'>
               КОРИСТУВАЧ дає свою згоду на передачу персональних даних третім
               особам без попереднього повідомлення КОРИСТУВАЧА, якщо це
               пов'язано з обробкою ЗАМОВЛЕННЯ КОРИСТУВАЧА і доставкою ТОВАРУ.
            </p>
            <p className='privacy__text'>
               Згода на обробку персональних даних КОРИСТУВАЧА діє весь час до
               моменту припинення обробки персональних даних.
            </p>
            <p className='privacy__text'>
               Як і багато інших компаній, perlynka-shoes-store.com використовує
               технологію cookies на своєму САЙТІ. Cookies - це уривки
               інформації, які САЙТ передає на жорсткий диск КОРИСТУВАЧА для
               зберігання інформації, пов'язаної з САЙТІ. Файли cookie
               використовуються для того, щоб підвищувати якість послуг, що
               надаються; для швидкої ідентифікації КОРИСТУВАЧА; збереження
               налаштувань КОРИСТУВАЧА, його персональних переваг, відстеження
               стану сесії доступу КОРИСТУВАЧА і характерних для нього
               тенденцій. perlynka-shoes-store.com також використовує файли
               cookie в рекламних цілях, в тому числі щоб управляти оголошеннями
               на сайтах в мережі Інтернет.
            </p>
            <p className='privacy__text'>
               За допомогою браузера файли cookie можна за бажанням заблокувати
               або видалити. Більш детальну інформацію дивіться в меню браузера.
               Зверніть увагу, що блокування всіх файлів cookie негативно вплине
               на зручність використання багатьох веб-сайтів, зокрема САЙТУ.
               perlynka-shoes-store.com рекомендує дозволити використання файлів
               cookie під час відвідування САЙТУ.
            </p>
            <p className='privacy__text'>
               perlynka-shoes-store.com повідомляє, що САЙТ використовує Google
               Analytics, пропоновану Google Inc. САЙТ використовує файли
               cookie, що зберігаються на пристрої КОРИСТУВАЧА, і відправляє
               дані, які будуть зберігатися на серверах Google. Цей процес
               дозволяє perlynka-shoes-store.com отримати доступ до статистики
               САЙТУ і проаналізувати поведінку КОРИСТУВАЧА. Завдяки цим діям
               perlynka-shoes-store.com може оптимізувати роботу САЙТУ і
               пропонувати високу якість своїх послуг. perlynka-shoes-store.com
               залишають поза передачею особисті дані в Google Inc., і єдиними
               файлами, якими perlynka-shoes-store.com володіє, є файли cookie,
               що стосуються використання САЙТУ КОРИСТУВАЧЕМ. Google Analytics
               використовується тільки для статистичних та аналітичних цілей.
            </p>
            <p className='privacy__text'>
               Політика конфіденційності perlynka-shoes-store.com і політика
               cookie є невід'ємною частиною Публічної Угоди сайту
               https://perlynka-shoes-store.com/
            </p>
         </div>
      </div>
   );
};

export default Privacy;
